module.exports = __webpack_public_path__ + "img/077-hail-1.db61a2e3.svg";